<template>
  <v-menu bottom left :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        :dark="dark"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list class="py-0">
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        @click="$emit(item.value)"
        :disabled="item.disabled"
      >
        <v-list-item-title v-if="item.color" :class="item.disabled ? '' : item.color">{{ item.title }}</v-list-item-title>
        <v-list-item-title v-else>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>